import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import '../styles/global.css';

const Login = ({ setUser }) => {
  const [credentials, setCredentials] = useState({ user: '', pass: '' });
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${config.apiBase}/login.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: credentials.user,
          password: credentials.pass
        })
      });

      const data = await response.json();

      if (data.success && data.user && data.token) {
        localStorage.setItem(config.tokenKey, data.token);
        localStorage.setItem(config.userKey,  JSON.stringify(data.user));
        setUser(data.user);
        navigate(config.defaultRoute);
      } else {
        setError(data.message || 'Identifiants incorrects');
      }
    } catch (err) {
      setError('Erreur de connexion au serveur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img className="brand-logo" src="/logo-isolacier.png" alt="Isolacier" />
          <h1>{config.clientName}</h1>
          <p>Connexion</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Utilisateur</label>
            <input
              type="text"
              placeholder="Votre identifiant"
              value={credentials.user}
              onChange={e => setCredentials({ ...credentials, user: e.target.value })}
              autoComplete="username"
              required
              autoFocus
            />
          </div>

          <div className="input-group">
            <label>Mot de passe</label>
            <input
              type="password"
              placeholder="Votre mot de passe"
              value={credentials.pass}
              onChange={e => setCredentials({ ...credentials, pass: e.target.value })}
              autoComplete="current-password"
              required
            />
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
